Core.PortalLogin = {
  init: function () {
    Core.PortalLogin.Cache = {
      $cbShowPassword: $(".showPassword"),
      $inputPassword: $("#password"),
    };

    // this.showHidePassword();

    // functions below are used on DVA registration. Initiation happen on step 3
    // this.handleTacCheckbox();
    // this.initPopup();
  },

  showHidePassword: function () {
    Core.PortalLogin.Cache.$cbShowPassword.on("change", function () {
      if (Core.PortalLogin.Cache.$inputPassword.attr("type") == "password")
        Core.PortalLogin.Cache.$inputPassword.attr("type", "text");
      else Core.PortalLogin.Cache.$inputPassword.attr("type", "password");
    });
  },

  handleTacCheckbox: function () {
    var $checkbox = $("#register #termsAndConditionsCheckbox");
    var $tacLink = $("#register a.termAndConditionPopup");

    $checkbox.on("change", function (e) {
      //keep chekbox unchanged
      var isChecked = this.checked;
      this.checked = !isChecked;
      $.uniform.update("#termsAndConditionsCheckbox");

      Core.PortalLogin.showPopup($("#tacPopup"), true);
    });

    $tacLink.on('click', function(e) {
      e.preventDefault();
      Core.PortalLogin.showPopup($("#tacPopup"), true);
    });
  },

  handleTacButtons: function(btnId, isSelected) {
    var $popup = $("#tacPopup");
    var $checkbox = $("#register #termsAndConditionsCheckbox");
    var $btnRegister = $('#btn-register2');

    $popup.find(btnId).on('click', function (e) {
      e.stopPropagation();
      $checkbox.prop('checked', isSelected);
      $.uniform.update('#termsAndConditionsCheckbox');

      if (isSelected) $btnRegister.removeClass('disabled').prop('disabled', false);
      else $btnRegister.addClass('disabled').prop('disabled', true);

      Core.PortalLogin.showPopup($popup, false);
    });
  },

  initPopup: function (title) {
    var _self = Core.PortalLogin;
    var _width = 660;
    var $popup = $("#tacPopup");

    if ($popup.length === 0) return;

    if (Core.IsMobile()) {
      _width = Core.Cache.$window.width();
    }

    $popup.kendoWindow({
      title: "TERMS & CONDITIONS",
      width: _width,
      visible: false,
      iframe: false,
      modal: true,
      resizable: false,
      actions: ["Close"],
      pinned: true,
      draggable: false,
      animation: false,
      appendTo: "#page-wrap",
    });

    _self.handleTacButtons('#btnCancelPopup', false);
    _self.handleTacButtons('#btnAgreePopup', true);
  },

  showPopup: function ($popup, doShow) {
    doShow = doShow == undefined || null ? true : doShow; //set default to true/show

    var popupWindow = $popup.data("kendoWindow");

    if (doShow) {
      popupWindow.center().open();
    } else {
      popupWindow.close();
    }
  },
};
